import { defineStore } from 'pinia';
import actions from './actions';
function initState() {
    return {
        blogListInfo: {
            blogs: [],
            count: 0,
            totalPages: 0,
            blogListTitle: '',
            pageSize: 0
        },
        categoryTitle: '',
        categories: [],
        showCategoryCount: true,
        searchInputPlaceholder: '',
        recentPostInfo: []
    };
}
export default (storeName) => defineStore(storeName, {
    state: initState,
    actions
});
